package com.crowpay.utils

import com.lightningkite.kiteui.AppScope
import com.lightningkite.kiteui.reactive.BaseImmediateReadable
import com.lightningkite.kiteui.reactive.Readable
import com.lightningkite.kiteui.reactive.shared
import com.lightningkite.now
import kotlinx.coroutines.Job
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlinx.datetime.Instant
import kotlin.time.Duration

class Countdown(val to: Instant): Readable<Duration> by shared(action = { (to - Now()).coerceAtLeast(Duration.ZERO) }) {
    object Now: BaseImmediateReadable<Instant>(now()) {
        private var job: Job? = null
            set(value) {
                field?.cancel()
                field = value
            }

        override fun activate() {
            job = AppScope.launch {
                while (true) {
                    value = now()
                    delay(1000)
                }
            }
        }

        override fun deactivate() {
            job = null
        }
    }
}